import React, { Component } from 'react';
import PropTypes from 'prop-types';
import sumBy from 'lodash/sumBy';
import './index.css';
import ErrorTooltip from '../../../page/components/ErrorTooltip';

export default class RatesTableComponent extends Component {
  constructor(props) {
    super(props);

    this.validateQuantity = this.validateQuantity.bind(this);

    this.state = {
      quantityErrors: false,
    }
  }


  componentDidMount() {
    const { getValidationFn } = this.props;
    if (getValidationFn) getValidationFn(this.validateQuantity);
  }

  componentDidUpdate(prevProps, prevState) {
    if (this.state.quantityErrors && prevProps.totalQuantity != this.props.totalQuantity) {
      this.setState({quantityErrors: false})
    }
  }

  validateQuantity() {
    const { translation, totalQuantity, minimumQuantity } = this.props;
    let errors = [];
    let error = false;

    if (totalQuantity <= 0) {
      error = translation.key('missingVariantMessage');
      errors.push(error);
    } else if (totalQuantity < minimumQuantity) {
      const message = translation.key('minimumQuantityMessage') || 'The total quantity must be at least';
      error = `${message}: ${minimumQuantity}`
      errors.push(error);
    }
    this.setState({quantityErrors: error});

    return errors
  }

  buildInputCounter(list, index) {
    const props = this.props.extraColumns[0];
    const rateKey = this.props.columns.headers[1];
    const item = this.props.items[list.key];
    const quantity = item ? item.quantity : 0;
    const unitMultiplier = item ? item.unit_multiplier : 1;
    const attr = props.attrs[list.key];
    const { max = null } = attr;
    const {
      title, body, button, errorText,
    } = this.props.style;
    const { translation } = this.props;
    const unavailable = max < (quantity * unitMultiplier);
    const nextValue = quantity + 1;
    const prevValue = quantity - 1 > 0 ? quantity - 1 : 0;
    const fontSize = body.fontSize >= '14px' ? `calc(${body.fontSize || '16px'} - 2px)` : '12px';
    const buttonStyle = { ...title, ...{ backgroundColor: button.backgroundColor, color: button.color } };
    const variantMaxAvailability = this.variantMaxAvailability(item, max);

    let name = `${list.key}_${props.header}`;

    if (translation.key('columnQuantity') === props.header) name = `${list.key}_quantity`;

    return (
      <React.Fragment key={`fragment-${list.key + index}`}>
        <tr key={list.key + index}>
          <td style={{fontSize: fontSize}}>
            {list[rateKey]}
          </td>
          <td className="counter">
            <div className="form-row">
              <div className="form-row__content">
                <button className="qtyminus" style={buttonStyle} onClick={() => props.onChange({ name, value: prevValue }, variantMaxAvailability)}>-</button>
                <input
                  {...attr}
                  name={name}
                  disabled
                  className="qty"
                  type="text"
                  style={{
                    ...title,
                    backgroundColor: body.backgroundColor,
                    color: this.state.quantityErrors ? '#CC0000' : title.color
                  }}
                  onInput={props.onChange.bind(this)}
                  value={quantity}
                />
                <button className="qtyplus" style={buttonStyle} onClick={() => props.onChange({ name, value: nextValue }, variantMaxAvailability)}>+</button>
              </div>
            </div>
          </td>
          {list[translation.key('columnPrice')] &&
            <td style={{fontSize: fontSize}}>
              {list[translation.key('columnPrice')]}
            </td>
          }
        </tr>
        {unavailable
        && (
        <tr key={`${list.key + index}-error`}>
                  <td colSpan="3" style={{ textAlign: 'center', padding: 0 }}>
                    <p style={{ color: errorText.color, margin: 0 }}>{this.props.limitedSpacesMessage || 'Sorry, limited spaces available'}</p>
                  </td>
        </tr>
        )}
      </React.Fragment>
    );
  }

  variantMaxAvailability(item, max) {
    const { capacityType, items } = this.props;
    if (capacityType == 1 || !max) return max;
    const otherItems = Object.values(items).filter((i) => i !== item),
    quantity = sumBy(otherItems, 'quantity');
    return max > quantity ? max - quantity : 0;
  }

  render() {
    const { columns: { lists }, translation } = this.props;
    const { quantityErrors } = this.state;

    return (
      <section>
        {quantityErrors &&
          <ErrorTooltip message={quantityErrors}/>
        }
        <div className="rates-table-container">
          <table className="pure-table pure-form center fluid">
            <tbody>
              {lists.map((list, i) => this.buildInputCounter(list, i))}
            </tbody>
          </table>
        </div>
      </section>
    );
  }
}

RatesTableComponent.propTypes = {
  columns: PropTypes.shape({
    headers: PropTypes.array.isRequired,
    lists: PropTypes.array.isRequired,
  }),
  extraColumns: PropTypes.arrayOf(
    PropTypes.shape({
      quantity: PropTypes.string,
      type: PropTypes.string.isRequired,
      onChange: PropTypes.func,
    }),
  ),
};
